<script lang="ts">
	import type { RestaurantDynamic, RestaurantSemiStatic, RestaurantsFoodResultPayload, RestaurantsSemiStatic, TileRestaurant } from "$lib/def/landing";
	import type { DealsLoader } from "$lib/serv/food-landing";
	import type { Cache } from "$lib/serv/core/cache";

	import { Vertical } from "$lib/def/verticals";
	import { page } from "$app/stores";

	import Grid from "$lib/ui/layout/Grid.svelte";
	import Tile from "../Tile.svelte";
	
	export let payload: RestaurantsFoodResultPayload;
	export let semistatic: RestaurantSemiStatic[] | undefined;
	export let dynamic: RestaurantDynamic[] | undefined;
	export let deals: DealsLoader | null;
	export let searchParams: Record<string, string>;

	function makeTileInfo(item: RestaurantsFoodResultPayload["items"][number], vertical: string | null): TileRestaurant {
		return {
			type: vertical as Vertical || Vertical.Restaurant,
			payload: {
				id: item.id,
			},
		};
	}
</script>

{#if semistatic !== null}
	<Grid cache={{payload}} type="restaurants" key={p => p?.items} let:item>
		<h3 slot="title" class="headline-m bold">{payload.name}</h3>
		{@const id = item.id}
		{@const ss = semistatic?.find(r => r.id === id)}
		{@const d = dynamic?.find(r => r.id === id)}
		{@const ds = deals?.restaurants?.get(id)}
		<Tile {searchParams} tile={makeTileInfo(item, $page.url.searchParams.get('search_vertical'))} semistatic={ss} dynamic={d} deals={ds} />
	</Grid>
{/if}